import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiPost, SUPER_TOKEN_KEY } from '../../api/client';

export function SuperLoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      const data = await apiPost<{ token: string }>(
        '/api/super/login',
        { email: email.trim(), password },
        undefined,
        { successMessage: 'Sesión de plataforma iniciada' }
      );
      localStorage.setItem(SUPER_TOKEN_KEY, data.token);
      nav('/super/orgs', { replace: true });
    } catch (ex) {
      setErr((ex as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={wrapPage}>
      <div style={wrap}>
        <div style={card}>
        <h1 style={{ margin: '0 0 8px', fontSize: 22 }}>Plataforma — super admin</h1>
        <p style={{ margin: '0 0 20px', color: '#64748b', fontSize: 14 }}>
          Alta de empresas y usuarios. URL reservada para operadores de la plataforma.
        </p>
        <form onSubmit={onSubmit}>
          <label style={label}>
            Email
            <input
              style={input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label style={label}>
            Contraseña
            <input
              style={input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {err ? <p style={{ color: '#b91c1c', fontSize: 14 }}>{err}</p> : null}
          <button type="submit" disabled={loading} style={btnPrimary}>
            {loading ? 'Entrando…' : 'Entrar'}
          </button>
        </form>
        <p style={{ margin: '20px 0 0', fontSize: 13, color: '#64748b' }}>
          Necesitás un usuario plataforma. Si no hay sesión, <strong>Modelos</strong> o <strong>Empresas</strong> te pedirán
          entrar otra vez.
        </p>
        </div>
      </div>
    </div>
  );
}

const wrapPage: React.CSSProperties = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
};

const wrap: React.CSSProperties = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
};

const card: React.CSSProperties = {
  width: '100%',
  maxWidth: 420,
  background: '#fff',
  borderRadius: 12,
  padding: 28,
  boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
};

const label: React.CSSProperties = {
  display: 'block',
  fontSize: 13,
  color: '#475569',
  marginBottom: 14,
};

const input: React.CSSProperties = {
  display: 'block',
  width: '100%',
  marginTop: 6,
  padding: '10px 12px',
  borderRadius: 8,
  border: '1px solid #cbd5e1',
  fontSize: 15,
};

const btnPrimary: React.CSSProperties = {
  width: '100%',
  marginTop: 8,
  padding: '12px',
  borderRadius: 8,
  border: 'none',
  background: '#312e81',
  color: '#fff',
  fontWeight: 600,
  fontSize: 15,
  cursor: 'pointer',
};
